import { render, staticRenderFns } from "./DefaultContentLayoutTalentMapping.vue?vue&type=template&id=42fe37b7"
import script from "./DefaultContentLayoutTalentMapping.vue?vue&type=script&lang=ts"
export * from "./DefaultContentLayoutTalentMapping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42fe37b7')) {
      api.createRecord('42fe37b7', component.options)
    } else {
      api.reload('42fe37b7', component.options)
    }
    module.hot.accept("./DefaultContentLayoutTalentMapping.vue?vue&type=template&id=42fe37b7", function () {
      api.rerender('42fe37b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scaffold/DefaultContentLayoutTalentMapping.vue"
export default component.exports